module.exports = "# Esmeralda and Goober Closing Story\n\nYouTube: tmfzNGOOsXM\n\n## Notes\nEsmeralda gives the Apprentices their fifth mission (1:12).\n"


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/sections/60_esClosingStory/level5_closing.md
// module id = 1864
// module chunks = 2